const KATEGORIJA_NAZIV = {
  RADNA_MASINA: "Radne masine",
  MASINA_UREDJAJ: "Masine i uredjaji",
  ORMARIC: "Gradilisni ormarici"
};

const KATEGORIJA_KOLONE = {
  RADNA_MASINA: [
    { header: "Naziv",             field: "vrsta_naziv" },
    { header: "Proizvođač",        field: "proizvodjac" },
    { header: "Tip / Model",       field: "tip" },
    { header: "Serijski broj",     field: "oznaka" },
    { header: "Registracija",      field: "registracija" },
    { header: "Br. preth. nalaza", field: "strucni_nalaz_broj" },
    { header: "Lokacija",          field: "lokacija" }
  ],
  MASINA_UREDJAJ: [
    { header: "Naziv",             field: "vrsta_naziv" },
    { header: "Tip / Model",       field: "tip" },
    { header: "Serijski broj",     field: "oznaka" },
    { header: "Br. preth. nalaza", field: "strucni_nalaz_broj" },
    { header: "Lokacija",          field: "lokacija" }
  ],
  ORMARIC: [
    { header: "Naziv",             field: "vrsta_naziv" },
    { header: "Oznaka (RO)",       field: "oznaka" },
    { header: "Serijski broj",     field: "serijski_broj" },
    { header: "Br. preth. nalaza", field: "strucni_nalaz_broj" },
    { header: "Lokacija",          field: "lokacija" },
    { header: "Objekat",           field: "objekat" }
  ]
};

function v(s, field) {
  const val = s[field];
  return val && String(val).trim() !== "" ? String(val) : "-";
}

function buildHTML({ kompanija, text, sredstva, contactData }) {
  const datum = new Date().toLocaleDateString("sr-RS", {
    day: "2-digit", month: "2-digit", year: "numeric"
  });

  const redosled = ["RADNA_MASINA", "MASINA_UREDJAJ", "ORMARIC"];
  const grupisano = sredstva.reduce((acc, s) => {
    const kat = s.kategorija || "OSTALO";
    if (!acc[kat]) acc[kat] = [];
    acc[kat].push(s);
    return acc;
  }, {});

  const tabele = [
    ...redosled.filter(k => grupisano[k]),
    ...Object.keys(grupisano).filter(k => !redosled.includes(k))
  ].map(kat => {
    const lista = grupisano[kat];
    const kolone = KATEGORIJA_KOLONE[kat] || [
      { header: "Naziv", field: "vrsta_naziv" },
      { header: "Lokacija", field: "lokacija" }
    ];
    const thead = kolone.map(k => "<th>" + k.header + "</th>").join("");
    const tbody = lista.map((s, i) =>
      '<tr class="' + (i % 2 === 1 ? "alt" : "") + '">' +
        kolone.map(k => "<td>" + v(s, k.field) + "</td>").join("") +
      "</tr>"
    ).join("");
    return (
      '<div class="kat-naslov">' + (KATEGORIJA_NAZIV[kat] || kat) + "</div>" +
      "<table><thead><tr>" + thead + "</tr></thead><tbody>" + tbody + "</tbody></table><br/>"
    );
  }).join("");

  const tekstHTML = text.split("\n").map(l => "<p>" + l + "</p>").join("");
  const kontaktHTML = contactData.split("\n").map(l => "<p>" + l + "</p>").join("");

  return "<!DOCTYPE html>" +
    '<html lang="sr"><head><meta charset="UTF-8"/>' +
    "<title>Zahtev za pregled opreme</title>" +
    "<style>" +
    "@media print { @page { margin: 15mm; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }" +
    "* { margin: 0; padding: 0; box-sizing: border-box; }" +
    "body { font-family: Arial, sans-serif; font-size: 10pt; color: #111; padding: 20px; }" +
    "h1 { text-align: center; font-size: 13pt; text-transform: uppercase; margin-bottom: 16px; }" +
    ".sec-title { font-size: 8pt; font-weight: bold; text-transform: uppercase; color: #666; border-bottom: 1px solid #aaa; padding-bottom: 2px; margin: 10px 0 6px; }" +
    ".row { display: flex; gap: 8px; margin-bottom: 3px; font-size: 9.5pt; }" +
    ".lbl { font-weight: bold; min-width: 70px; color: #444; }" +
    "p { font-size: 9.5pt; line-height: 1.5; margin-bottom: 2px; }" +
    ".kat-naslov { font-size: 8.5pt; font-weight: bold; background: #e2e2e2; padding: 3px 6px; margin-top: 6px; }" +
    "table { width: 100%; border-collapse: collapse; font-size: 8pt; margin-top: 0; }" +
    "thead tr { background: #3c5a78; color: #fff; }" +
    "th { padding: 4px 5px; text-align: left; border: 1px solid #2a4560; }" +
    "td { padding: 3px 5px; border: 1px solid #ddd; vertical-align: top; }" +
    "tr.alt td { background: #f5f5f5; }" +
    ".footer { margin-top: 14px; font-size: 7.5pt; color: #888; border-top: 1px solid #ddd; padding-top: 4px; }" +
    "</style></head><body>" +
    "<h1>Zahtev za pregled i proveru opreme za rad</h1>" +
    '<div class="sec-title">Podaci o firmi</div>' +
    '<div class="row"><span class="lbl">Naziv:</span><span>' + (kompanija?.company_name || "-") + "</span></div>" +
    '<div class="row"><span class="lbl">Adresa:</span><span>' + (kompanija?.company_address || "-") + "</span></div>" +
    '<div class="row"><span class="lbl">PIB:</span><span>' + (kompanija?.pib || "-") + "</span></div>" +
    '<div class="sec-title">Zahtev</div>' + tekstHTML +
    '<div class="sec-title">Sredstva i oprema</div>' + tabele +
    '<div class="sec-title">Kontakt</div>' + kontaktHTML +
    '<div class="footer"><span>Datum: ' + datum + "</span></div>" +
    "</body></html>";
}

export async function generisiPDF({ kompanija, text, sredstva, contactData }) {
  const html = buildHTML({ kompanija, text, sredstva, contactData });
  const win = window.open("", "_blank", "width=900,height=700");
  win.document.write(html);
  win.document.close();
  win.onload = function () {
    win.focus();
    win.print();
  };
}